import Link from "next/link";
import { buttonVariants } from "@/components/ui/button-variants";
import {
  NavChevronDown,
  navigationMenuTriggerStyle,
  resolveHref,
} from "@/components/layout/nav-shared";
import type { NavGroup } from "@/lib/content/types";
import { type Locale } from "@/lib/i18n/config";
import { cn } from "@/lib/utils";

export default function DesktopNavigationFallback({
  locale,
  mainNavigation,
  pricingNavLink,
  className,
}: {
  locale: Locale;
  mainNavigation: NavGroup[];
  pricingNavLink: { href: string; label: string };
  className?: string;
}) {
  return (
    <nav
      aria-label="Main"
      className={cn(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        className,
      )}
    >
      <ul className="flex flex-1 list-none items-center justify-center gap-0">
        {mainNavigation.map((group) => (
          <li key={group.label} className="relative">
            <span
              className={cn(
                navigationMenuTriggerStyle(),
                "group pointer-events-none",
              )}
            >
              {group.label} <NavChevronDown className="relative top-px ml-1" />
            </span>
          </li>
        ))}
        <li className="relative">
          <Link
            href={resolveHref(pricingNavLink.href, locale)}
            className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}
          >
            {pricingNavLink.label}
          </Link>
        </li>
      </ul>
    </nav>
  );
}
